import Repository from '../Repository';

const url = '/admin/user';

export default {
    getAllUsers(page, filter) {
        return Repository.get(`${url}?page=${page}`, {
            params: {
                blocked: filter.blocked,
                subscribed: filter.subscribed,
                referred: filter.referred,
                health: filter.health,
                name: filter.name
            }
        }, {
            localLoading: true
        });
    },
    getUser(user) {
        return Repository.get(`${url}/${user}`, {
            localLoading: true
        });
    },
    updateUser(user, payload) {
        return Repository.patch(`${url}/${user}`, payload);
    },

    getStatsBetween(user, dateFrom, dateTo) {
        return Repository.get(`${url}/${user}/training-completions?from=${dateFrom}&to=${dateTo}`);
    },

    getCounters(user, dateFrom, dateTo) {
        return Repository.get(`${url}/${user}/training-counters?from=${dateFrom}&to=${dateTo}`)
    },

    getUserSubsciptionInfo(user) {
        return Repository.get(`${url}/${user}/subscription/status`, {
            localLoading: true
        });
    },
    getUserHealthQuestions(user) {
        return Repository.get(`${url}/${user}/questions`, {
            localLoading: true
        });
    },
    blockUser(user) {
        return Repository.get(`${url}/${user}/block`, {
            localLoading: true
        });
    },
    unblockUser(user) {
        return Repository.get(`${url}/${user}/unblock`, {
            localLoading: true
        });
    }


}
